const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || "/api";

export async function adminRequest<TResponse>(
  token: string,
  path: string,
  init?: RequestInit
): Promise<TResponse> {
  const response = await fetch(`${apiBaseUrl}${path}`, {
    ...init,
    headers: {
      "content-type": "application/json",
      authorization: `Bearer ${token}`,
      ...(init?.headers ?? {})
    }
  });

  if (!response.ok) {
    const body = await response.json().catch(() => null);
    throw new Error(body?.error?.message || `API request failed with ${response.status}`);
  }

  return response.json() as Promise<TResponse>;
}

export async function adminUploadRequest<TResponse>(
  token: string,
  path: string,
  file: File,
  headers: Record<string, string>
): Promise<TResponse> {
  const response = await fetch(`${apiBaseUrl}${path}`, {
    method: "POST",
    body: await file.arrayBuffer(),
    headers: {
      authorization: `Bearer ${token}`,
      "content-type": file.type || "application/octet-stream",
      ...headers
    }
  });

  if (!response.ok) {
    const body = await response.json().catch(() => null);
    throw new Error(body?.error?.message || `API upload failed with ${response.status}`);
  }

  return response.json() as Promise<TResponse>;
}
